// Local image paths for the villa gallery
export const villaImages = [
  '/images/Night-Villa-view-1.png',
  '/images/Living-Space-AEB-View-1.png',
  '/images/IMG_5949.JPG',
  '/images/IMG_5770.JPG',
  '/images/IMG_5757.JPG',
  '/images/Villa-In-Main-view-1.jpg',
  '/images/Villa-Garden-view-3.jpg',
  '/images/Villa-Pool-view-1.jpg',
  '/images/Villa-Pool-view-4.jpg',
  '/images/Villa-Pool-view-6.jpeg',
  '/images/Villa-Pool-view-7.jpg',
  '/images/Villa-Bathroom-view-1.jpg',
  '/images/Villa-Bedroom-view-1.jpg',
  '/images/Villa-Bedroom-view-2.jpg',
  '/images/Villa-Bedroom-view-3.jpg',
  '/images/Villa-Kitchen-view-1.jpg',
  '/images/Villa-Front-Night-view-1.jpg',



];

// Hero images for the homepage slideshow
export const heroImages = [
  {
    url: '/images/Night-Villa-view-1.png',
    title: 'Villa DINOOS',
    subtitle: 'Experience the comfort of home in luxurious surroundings'
  },
  {
    url: '/images/IMG_5770.JPG',
    title: 'Elegant Interiors',
    subtitle: 'Thoughtfully designed spaces for your perfect getaway'
  },
  {
    url: '/images/Villa-Garden-view-3.jpg',
    title: 'Peaceful Gardens',
    subtitle: 'Surrounded by nature\'s tranquil beauty'
  },
  {
    url: '/images/Living-Space-AEB-View-1.png',
    title: 'Luxurious Comfort',
    subtitle: 'Every detail crafted for your relaxation'
  },
  {
    url: '/images/Villa-Pool-view-8.jpg',
    title: 'Modern Amenities',
    subtitle: 'All the comforts you need for a perfect stay'
  },
  {
    url: '/images/Villa-Pool-view-6.jpeg',
    title: 'Privacy, Relaxation & Luxury',
    subtitle: 'Calm and serene environment for your vacation'
  },
  {
    url: '/images/Villa-Pool-view-7.jpg',
    title: 'Perfect for private relaxing weekend',
    subtitle: 'Complete with a luxurious pool, with a jacuzzi!'
  }
];

// Fallback images from Pexels (in case local images are not available)
export const fallbackImages = [
  // 'https://images.pexels.com/photos/338504/pexels-photo-338504.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
  // 'https://images.pexels.com/photos/1743231/pexels-photo-1743231.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
  // 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
  // 'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
  // 'https://images.pexels.com/photos/1571453/pexels-photo-1571453.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop'
];